import React, {Component} from "react";
import './Recherche.css'

class Recherche extends Component {
    state= {
        numero_etudiant: "",
        nom_ar: "",
        prenom_ar: "",
        etudiant: "",
        etudiants: []
    }

    clickRow = (e) => {
        let url = "/modifier/" + e.currentTarget.id
            this.props.history.push(url)
    }

    recherche = () => {
        document.getElementsByClassName('resultat-un-etudiant')[0].style.display= "none"
        document.getElementsByClassName('resultat-no-ok')[0].style.display= ""
        document.getElementsByClassName('resultat-plusieurs-etudiants')[0].style.display= "none"
    }

    matriculeChange = (e) => {
        this.setState({ numero_etudiant: e.target.value })
        document.getElementsByClassName('resultat-un-etudiant')[0].style.display= "none"
        document.getElementsByClassName('resultat-no-ok')[0].style.display= "none"
        document.getElementsByClassName('resultat-plusieurs-etudiants')[0].style.display= "none"
        if(e.target.value.length > 0) {
            document.getElementById('nom_ar').style.display = 'none'
            document.getElementById('prenom_ar').style.display = 'none'
        } else {
            document.getElementById('nom_ar').style.display = ''
            document.getElementById('prenom_ar').style.display = ''
        }
    }

    nomChange = (e) => {
        this.setState({ nom_ar: e.target.value })
    }

    prenomChange = (e) => {
        this.setState({ prenom_ar: e.target.value })
    }

    componentDidMount() {
        document.getElementsByClassName('resultat-un-etudiant')[0].style.display= "none"
        document.getElementsByClassName('resultat-no-ok')[0].style.display= "none"
        document.getElementsByClassName('resultat-plusieurs-etudiants')[0].style.display= ""
}

    render() {

        return(

            <div className="container-recherche-etudiant">
                <h2>البحث عن طالب</h2>
                <div className="sous-container-nouveau-etudiant">
                    <div id="matricule">
                        <label>رقم الطالب</label>
                        <input dir="ltr" name="numero_etudiant" type="text" onChange={this.matriculeChange} value={this.state.numero_etudiant} placeholder=""/>
                    </div>
                    <div id="nom_ar">
                        <label>اللقب</label>
                        <input name="nom_ar" type="text" onChange={this.nomChange} value={this.state.nom_ar} placeholder=""/>
                    </div>
                    <div id="prenom_ar">
                        <label>الإسم</label>
                        <input name="prenom_ar" type="text" onChange={this.prenomChange} value={this.state.prenom_ar} placeholder=""/>
                    </div>

                    <div>
                        <input type='submit' value='بحث' onClick={this.recherche} />
                    </div>
                    <div className="resultat-un-etudiant" style={{display: "none", marginTop: "10px", fontWeight: "bold"}}>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">رقم الطالب</label>
                            <label className="etudiant-lable2">{this.state.etudiant.numero_etudiant}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">اللقب</label>
                            <label className="etudiant-lable2">{this.state.etudiant.nom_ar}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">الإسم</label>
                            <label className="etudiant-lable2">{this.state.etudiant.prenom_ar}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">تاريخ الميلاد</label>
                            <label className="etudiant-lable2">{this.state.etudiant.date_naissance}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">مكان الميلاد</label>
                            <label className="etudiant-lable2">{this.state.etudiant.lieu_naissance}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">الطور</label>
                            <label className="etudiant-lable2">{this.state.etudiant.cycle}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">السنةالحالية</label>
                            <label className="etudiant-lable2">{this.state.etudiant.annee_actuelle}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">الشعبة</label>
                            <label className="etudiant-lable2">{this.state.etudiant.specialite_generale}</label>
                        </div>
                        <div className="etudiant-resultat">
                            <label className="etudiant-lable1">التخصص</label>
                            <label className="etudiant-lable2">{this.state.etudiant.specialite_speciale}</label>
                        </div>
                    </div>
                    <div className="resultat-plusieurs-etudiants" style={{display: "none", marginTop: "10px"}}>
                        <table>
                            <thead>
                            <tr>
                                <th>رقم الطالب</th>
                                <th>اللقب</th>
                                <th>الإسم</th>
                                <th>الطور</th>
                                <th>السنة</th>
                                <th>الشعبة</th>
                                <th>الإختصاص</th>
                                <th>المجموعة</th>
                                <th>الفوج</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.etudiants.reverse().map(etudiant =>
                                <tr id={etudiant.id} key={etudiant.id} onClick={this.clickRow}>
                                    <td>{etudiant.numero_etudiant}</td>
                                    <td>{etudiant.nom_ar}</td>
                                    <td>{etudiant.prenom_ar}</td>
                                    <td>{etudiant.cycle}</td>
                                    <td>{etudiant.annee_actuelle}</td>
                                    <td>{etudiant.specialite_generale}</td>
                                    <td>{etudiant.specialite_speciale}</td>
                                    <td>{etudiant.section}</td>
                                    <td>{etudiant.groupe}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="resultat-no-ok" style={{display: "none", marginTop: "10px", fontWeight: "bold"}}>
                        <label>لا يوجد إي طالب يطابق هذا البحث</label>
                    </div>
                    <div className="alert" style={{display: "none", position: "absolute", bottom: 70, width: "300px"}}>
                        <span className="closebtn" onClick={this.hideAlert}>&times;</span>

                    </div>
                </div>
            </div>

        )
    }
}

export default Recherche